import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Sparkle } from "lucide-react";
function Divider() {
  return;
}
export default function HeroSection() {
  return <section data-section-id="223224" id="nurturing-your-journey-to-motherhood" className="relative w-full h-screen flex flex-col items-center bg-background justify-center text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640790/img/newborn_mother_arms_hero.png)] bg-cover bg-left bg-no-repeat bg-fixed opacity-70" aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-background/20 via-transparent to-background/40 md:to-background md:to-[40%] md:from-transparent md:from-[60%]" aria-hidden="true" />

      {}
      <div className="relative z-10 flex flex-col items-center text-center max-w-5xl mx-auto space-y-8 !p-0">
        <h1 className="text-4xl md:text-6xl lg:text-7xl text-primary tracking-tight drop-shadow-sm !font-serif !font-light px-6 md:px-0">
          You Shouldn’t Have to Navigate Birth Alone
        </h1>

        <p className="text-base md:text-xl lg:text-2xl max-w-3xl font-default drop-shadow-none font-medium text-primary-foreground">Personalized doula support for mothers who want to feel informed, confident, and cared for through pregnancy, birth, and postpartum.</p>

        <div className="!p-0">
          <Button asChild size="lg" className="px-6 text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-14 rounded-full font-semibold tracking-wide shadow-xl shadow-primary/20 transition-all ![margin:0px_5px_0px_5px] !text-lg ![padding:7px_15px_7px_15px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent/90 hover:scale-105 bg-secondary text-primary">
            <Link to="https://hello.dubsado.com:443/public/appointment-scheduler/662a79049b3568003af78fe0/schedule">Schedule Your Free Consultation</Link>
          </Button>
        </div>
      </div>

      <Divider />
    </section>;
}